import { render, staticRenderFns } from "./EditCost.vue?vue&type=template&id=2eff84ff&scoped=true&"
import script from "./EditCost.vue?vue&type=script&lang=js&"
export * from "./EditCost.vue?vue&type=script&lang=js&"
import style0 from "./EditCost.vue?vue&type=style&index=0&id=2eff84ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eff84ff",
  null
  
)

export default component.exports